package ir.hosen.resume.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.functions.blur
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.forms.ButtonSize
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import ir.hosen.resume.pages.Theme
import ir.hosen.resume.styles.NavTabItemStyle
import ir.hosen.resume.styles.ToggleTheme
import ir.hosen.resume.util.Res
import ir.hosen.resume.util.ScreenItem
import ir.hosen.resume.util.bps
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Img

@Composable
fun NavBar(onClick: (String) -> Unit, onToggleTheme: () -> Unit) {
    Row(
        modifier = Modifier
            .width(100.percent)
            .background(Colors.Transparent)
            .backdropFilter(blur(3.5.px))
            .position(Position.Fixed)
            .top(0.px)
            .left(0.px)
            .zIndex(1000)
            .padding(16.px),
        horizontalArrangement = Arrangement.Center,
        verticalAlignment = Alignment.CenterVertically
    ) {
        ScreenItem.entries.forEach { tab ->
            Button(
                modifier = NavTabItemStyle.toModifier(),
                size = ButtonSize.SM,
                onClick = {
                    onClick(tab.id)
                }
            ) {
                SpanText(
                    modifier = Modifier
                        .color(Theme.onBackgroundColor)
                        .fontFamily(Res.String.ROBOTO_REGULAR)
                        .fontSize(18.bps()), text = tab.title
                )
            }
        }

        Box(
            modifier = ToggleTheme.toModifier().size(40.px).onClick { onToggleTheme() },
            contentAlignment = Alignment.Center
        ) {
            Img(
                src = if (Theme.isDark) "/sun.svg" else "/moon.svg",
                attrs = Modifier.size(18.px).toAttrs()
            )
        }

    }
}